export default "__VITE_ASSET__CqUiQHPh__"